import React, {useEffect} from 'react'
import styled from '@emotion/styled'
import {keyframes} from '@emotion/react'
import {usePaymentAuth} from './contexts/payment-auth-context'
import {usePaymentOrder} from './hooks/use-payment-order'
import {OtpVerification} from './otp-verification'
import {PaymentInformation} from '../../screens/payment-information'

const spinAnim = keyframes`
  to { transform: rotate(360deg); }
`

const LoadingOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(23, 29, 55, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const LoadingSpinner = styled.span`
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffffff;
  animation: ${spinAnim} 0.7s linear infinite;
`

function LoadingShell() {
  return (
    <LoadingOverlay>
      <LoadingSpinner />
    </LoadingOverlay>
  )
}

export function PaymentInformationGate() {
  const {isVerified, mfaRequired, authToken, checkStatus, flowType} =
    usePaymentAuth()
  const {randomId} = usePaymentOrder()

  useEffect(() => {
    if (randomId) {
      checkStatus(randomId)
    }
  }, [randomId, checkStatus])

  // Still loading status
  if (mfaRequired === null) {
    return <LoadingShell />
  }

  // Non-MFA path: wait for the scoped token from /status before mounting
  // PaymentInformation — otherwise downstream auth'd API calls fire with no
  // Bearer and fail with 401.
  if (!mfaRequired) {
    return authToken ? <PaymentInformation /> : <LoadingShell />
  }

  if (isVerified || flowType === 'Proposal') {
    return <PaymentInformation />
  }

  return <OtpVerification />
}
